import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import CertifiedBy from './components/CertifiedBy';
import PromiseBand from './components/PromiseBand';
import Services from './components/Services';
import MembraneSystems from './components/MembraneSystems';
import Realizations from './components/Realizations';
import AboutCompany from './components/AboutCompany';
import WhyUsAndProcess from './components/WhyUsAndProcess';
import Reviews from './components/Reviews';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';
import PrintMaterials from './components/PrintMaterials';
import CookieConsent from './components/CookieConsent';

const Home = () => (
  <div className="bg-black min-h-screen">
    <Header />
    <Hero />
    <CertifiedBy />
    <PromiseBand />
    <Services />
    <MembraneSystems />
    <Realizations />
    <AboutCompany />
    <WhyUsAndProcess />
    <Reviews />
    <ContactCTA />
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/druk" element={<PrintMaterials />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent />
    </div>
  );
}

export default App;
